module.exports = __webpack_public_path__ + "static/img/silver.0d320565.png";